import type { ControllerExecutionSuccessResult, ControllerQueryParameters } from '@carlito/ddd';
import type { GetGuestController } from '@carlito/hotel-apis';
import { ApiRequestBaseParams, apiRequest } from './api';

export type GetGuestParams = ControllerQueryParameters<GetGuestController>;
export type GetGuestResponse = ControllerExecutionSuccessResult<GetGuestController>;

export async function getGuest({
  accessToken,
  apiKey,
  ...params
}: GetGuestParams & ApiRequestBaseParams) {
  const result = await apiRequest<GetGuestController>('/guest', {
    queryParameters: params,
    method: 'GET',
    accessToken,
    apiKey,
  });

  return result;
}

// Original UserResponse type
type UserResponse = {
  log?: {
    data?: {
      namel: string;
    };
  };
};

type MakeRequired<T> = {
  [K in keyof T]-?: T[K];
};

// Make name property required
type UserData = MakeRequired<MakeRequired<UserResponse>['log']>['data'];
// Test
const x: UserData = { namel: 'test' }; // This will not raise an error
